<script setup>
// Destructive confirmation in the product's own dialog instead of window.confirm.
// Usage: `confirmRef.open({ title, description, confirmLabel, onConfirm })` — the dialog stays open
// while onConfirm runs and closes on success, so a failing request keeps the context on screen.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();

const dialogRef = ref(null);
const isLoading = ref(false);
const content = ref({ title: '', description: '', confirmLabel: '' });
let onConfirm = null;

const open = ({
  title = '',
  description = '',
  confirmLabel = '',
  onConfirm: handler = null,
} = {}) => {
  content.value = { title, description, confirmLabel };
  onConfirm = handler;
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const confirm = async () => {
  isLoading.value = true;
  try {
    await onConfirm?.();
    close();
  } finally {
    isLoading.value = false;
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    width="sm"
    :title="content.title"
    :description="content.description"
    :confirm-button-label="content.confirmLabel || t('WASAPI_COMMON.DELETE')"
    :is-loading="isLoading"
    @confirm="confirm"
  />
</template>
